import _ from 'lodash';
import dialogs from '../dialog';
import drawing from '../map/draw';

import SelectionFactory from './SelectionFactory';
import SelectionTypeFactory from './SelectionTypeFactory';
import api from "../../api";
import { ContextEnum } from '../../../enuns/context.enum';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

class Selection {
    static getInstance() {
        if (!Selection._instance) {
            Selection._instance = new Selection();
        }

        return Selection._instance;
    }

    init() {
        const $enableButton = $('#tool-selection');
        $enableButton.parent().show();
        $enableButton.on('click', (e) => {
            if (!drawing.visible) {
                drawing.show({
                    polygon: true,
                    rectangle: true,
                    circle: true
                }, (event) => {
                    const options = SelectionFactory.getAvailableOptions();
                    api.general.log.action(ContextEnum.SelectTool, 'enable', JSON.stringify({
                      GeometryType: event.layerType
                    }));
                    if (_.size(options) === 1) {
                        if (options[0].value === 'stores')
                            this.storesOptions(event);
                        else if (options[0].value === 'multicriteriaAfterSales')
                            this.multicriteriaOptions(event);
                        else
                            return new SelectionFactory(options[0].type, event);
                    } else {
                        dialogs.select(options, (type) => {
                            if (type === 'stores') {
                                this.storesOptions(event);
                            }
                            else {
                                return new SelectionFactory(type, event);
                            }
                        }, () => {
                            drawing.removeLayer();
                        });
                    }
                });

                $(drawing.getControls().getContainer()).hide();
            }
        });

        const $disableButton = $('#tool-selection-remove');
        $disableButton.on('click', () => {
            drawing.hide();
        });
    }

    multicriteriaOptions(event) {
        setTimeout(() => {
            const optionsStore = SelectionTypeFactory.getMulticriteriaOptions();
            dialogs.select(optionsStore, (type) => {
                new SelectionFactory(type, event);
                drawing.removeLayer();
            }, () => {
                $(drawing.getControls().getContainer()).hide();
            });
        }, 100);
    }

    storesOptions(event){
        setTimeout(() => {
            const optionsStore = SelectionTypeFactory.getAvailableOptions();
            if (_.size(optionsStore) === 1 && isAuthorized('Direct-sales-filters-channels'))
                return new SelectionTypeFactory('directSales', event);

            if (_.size(optionsStore) === 1 && !isAuthorized('Direct-sales-filters-channels'))
                return new SelectionTypeFactory('retail', event);

            dialogs.select(optionsStore, (type) => {
                return new SelectionTypeFactory(type, event);
            }, () => {
                $(drawing.getControls().getContainer()).hide();
            });
        }, 100);
    }
}

export default Selection;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/index.js